import { BarChart3, CalendarDays, Clock, CloudSun, ListChecks, MapPin, Newspaper, SquareKanban, Type, type LucideIcon } from 'lucide-react';

/** The widgets, each with its own settings page under Settings → Widgets. */
export type WidgetPageId = 'clock' | 'location' | 'weather' | 'calendar' | 'lists' | 'planner' | 'powerbi' | 'news' | 'text';

/** Where each widget's settings live (all have `enabled`). */
export type WidgetKey = 'clock' | 'photoInfo' | 'weather' | 'calendar' | 'lists' | 'planner' | 'powerbi' | 'news' | 'text';

export const WIDGET_PAGES: Array<{ id: WidgetPageId; name: string; icon: LucideIcon; key: WidgetKey }> = [
  { id: 'clock', name: 'Clock', icon: Clock, key: 'clock' },
  // The key stays 'photoInfo' so settings saved before it became the Location widget carry over.
  { id: 'location', name: 'Location', icon: MapPin, key: 'photoInfo' },
  { id: 'weather', name: 'Weather', icon: CloudSun, key: 'weather' },
  { id: 'calendar', name: 'Calendar', icon: CalendarDays, key: 'calendar' },
  { id: 'lists', name: 'To-do lists', icon: ListChecks, key: 'lists' },
  { id: 'planner', name: 'Planner', icon: SquareKanban, key: 'planner' },
  { id: 'powerbi', name: 'Power BI', icon: BarChart3, key: 'powerbi' },
  { id: 'news', name: 'News', icon: Newspaper, key: 'news' },
  { id: 'text', name: 'Text', icon: Type, key: 'text' },
];
